@let showClearButton = canResetToDefault();
<div class="flex-row" [class]="selectClass">
  <mat-select
    [(ngModel)]="selectionModel"
    [multiple]="multiple"
    [placeholder]="placeholder"
    [panelClass]="panelClass"
    [class]="selectClass"
    [class.mat-mdc-select-invalid]="isInvalid"
    [class.select-with-clear]="showClearButton"
    [disabled]="disabled"
    [compareWith]="compareItems"
    [tooltip]="tooltip"
    (closed)="onClosed()"
  >
    @if (multiple && triggerLabel) {
      <mat-select-trigger>{{ triggerLabel }}</mat-select-trigger>
    }

    @for (item of fixedItems; track item.id; let isLast = $last) {
      <mat-option
        #option
        [class.bottom-divider]="isLast"
        [disabled]="item.disabled ?? false"
        [value]="item"
        [tooltip]="item.tooltip"
        [showDelay]="500"
        (click)="onFixedItemClick(item, option.selected)"
        shared-title-if-ellipse
        >{{ item.label }}</mat-option
      >
    }

    @if (items?.length > 5) {
      <mat-option>
        <shared-select-search [(ngModel)]="filter" [searchPlaceholder]="searchPlaceholder"></shared-select-search>
      </mat-option>
    }

    @for (group of groups$ | async; track group.label) {
      @if (group.label && (groups$ | async).length > 1) {
        <mat-optgroup>
          <b>{{ group.label | uppercase }}</b>
          @for (item of group.items; track item.id) {
            <mat-option [disabled]="item.disabled ?? false" [value]="item" [tooltip]="item.tooltip" [showDelay]="500" (click)="onItemClick()" shared-title-if-ellipse
              >{{ item.label }}{{ item.description ? ' (' + item.description + ')' : '' }}</mat-option
            >
          }
        </mat-optgroup>
      }

      @if (!group.label || (groups$ | async).length === 1) {
        @for (item of group.items; track item.id) {
          <mat-option [disabled]="item.disabled ?? false" [value]="item" [tooltip]="item.tooltip" [showDelay]="500" (click)="onItemClick()" shared-title-if-ellipse
            >{{ item.label }}{{ item.description ? ' (' + item.description + ')' : '' }}</mat-option
          >
        }
      }
    }
  </mat-select>
  @if (showClearButton) {
    <button class="btn btn-outline-secondary clear-button" tooltip="Clear selection" [showDelay]="500" [disabled]="disabled" (click)="resetToDefault()">
      <svg-icon class="color-gray" key="close" size="xs" />
    </button>
  }
</div>
